<template>
  <div class="trading-competition bg--color-02">
    <div class="container-new pb-48--l">
      <div class="trading-competition__header mb-32--m pb-16--m mb-16">
        <div class="trading-competition__info pt-32 mt-16">
          <h2
            class="txt--bold txt--26px txt--52px--l txt--height-34px txt--height-64px--l txt--color-04 mb-10 mb-12--l"
          >
            {{ $t('tradingCompetition.title') }}
          </h2>
          <p
            class="txt--color-03 txt--14px txt--22px--l txt--height-18px txt--height-30px--l mb-0"
          >
            {{ $t('tradingCompetition.desc') }}
          </p>
        </div>
        <!-- <div class="trading-competition__img">
          <img
            src="@/assets/img/trading-competition/header-image.svg"
            alt="hand with coin image"
          >
        </div> -->
      </div>

      <div>
        <span v-if="loading" class="txt--main">
          <exc-loader />
        </span>

        <div v-else>
          <base-empty-card v-if="!tradingCompetitionCards.length" />

          <div v-else class="trading-competition__cards">
            <trading-competition-card
              v-for="(item, indx) in tradingCompetitionCards"
              :key="indx"
              :comp="item"
              :dropdown-open-up="item.dropdownOpensUp"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import { ExcLoader } from '@/components/common'
import { getDefaultHeadData } from '@/lib/utils'

export default {
  name: 'TradingCompetition',
  components: {
    ExcLoader,
    TradingCompetitionCard: () =>
      import(
        /* webpackMode: "eager" */ '@/components/trading-competition/card/TradingCompetitionCard.vue'
      ),
    BaseEmptyCard: () =>
      import(/* webpackMode: "eager" */ '@/components/base/BaseEmptyCard.vue'),
  },
  data () {
    return {
      loading: false,
    }
  },
  head () {
    return getDefaultHeadData({
      title: this.$t('meta.tradingCompetition.title'),
      description: this.$t('meta.tradingCompetition.description'),
      locale: this.$i18n.locale,
    })
  },
  computed: {
    ...mapState({
      isLogined: state => state.auth.loggedIn,
    }),
    ...mapGetters({
      items: 'tradingCompetition/getTradingCompetitions',
    }),
    tradingCompetitionCards () {
      return this.items || []
    },
    linkTo () {
      if (this.isLogined) {
        return '/trading-competition/history'
      }
      return '/login'
    },
    itemsSlice () {
      // hotfix
      return window.innerWidth < 768 ? 4 : 3
    },
  },

  async created () {
    this.loading = true
    await this.getTradingCompetition()
    this.loading = false
  },

  methods: {
    ...mapActions('tradingCompetition', {
      getTradingCompetition: 'getTradingCompetition',
    }),
  },
}
</script>

<style lang="scss" scoped>
.trading-competition {
  display: flex;
  flex-direction: column;
  flex: 1;

  &__header {
    @include bp(l) {
      display: flex;
      justify-content: space-between;
      gap: toRem(20px);
    }
  }

  &__img {
    @include bp(0, l) {
      display: none;
    }

    img {
      max-width: toRem(475px);
      max-height: toRem(232px);
    }
  }

  &__cards {
    display: grid;
    gap: toRem(10px);

    @include bp(l) {
      grid-template-columns: repeat(2, 1fr);
    }

    @include bp(ml) {
      grid-template-columns: repeat(3, 1fr);
      gap: toRem(20px);
    }
  }

  &__no-projects-img {
    width: 100%;
    height: 100%;
    max-width: toRem(80px);
  }
}
</style>
